@if (label) {
  <app-control-header [label]="label" [index]="index" [required]="required"></app-control-header>
}
<div
  class="check-box-icon group flex items-center gap-3 font-main text-navy-90 overflow-hidden"
  (click)="label && toggle()"
>
  <div class="flex" [ngClass]="{ 'opacity-75 group-hover:opacity-100': !value && !partiallyChecked }">
    <ng-container *ngTemplateOutlet="checkBoxSwitch"></ng-container>
  </div>

  @if (doesHaveText) {
    <div
      class="value-label-wrapper flex gap-1 items-center overflow-hidden"
      [ngClass]="{ 'text-navy-70 group-hover:text-navy-90': !value && !partiallyChecked }"
    >
      @if (!valueLabel) {
        <ng-content></ng-content>
      } @else {
        @if (icon) {
          <svg-icon class="w-4.5 h-4.5" preserveAspectRatio="none" [stretch]="true" [src]="icon"></svg-icon>
        }
        <span
          placement="top"
          class="label-text w-inherit truncate"
          [ngbTooltip]="valueLabel"
          [openTooltipWhenOverflowedAndHovered]="true"
          [openOnWidthOverflow]="true"
        >
          {{ valueLabel }}
        </span>
      }
    </div>
  }
</div>

<ng-template #checkBoxSwitch>
  @switch (checkBoxVariantClass) {
    @case ('partially-checked') {
      <ng-container *ngTemplateOutlet="partialCheckBox"></ng-container>
    }

    @case ('multiselect') {
      <ng-container *ngTemplateOutlet="roundedCheckBox"></ng-container>
    }

    @default {
      <ng-container *ngTemplateOutlet="squareCheckBox"></ng-container>
    }
  }
</ng-template>

<ng-template #partialCheckBox>
  <svg class="checkbox p-0" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect class="border" x="0.5" y="0.5" width="17" height="17" rx="2.5" stroke="#04293E" />
    <line class="checkmark" x1="4" y1="8.5" x2="14" y2="8.5" stroke="#04293E" />
  </svg>
</ng-template>

<ng-template #squareCheckBox>
  <svg class="checkbox" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect class="border" x="0.5" y="0.5" width="17" height="17" rx="2.5" />
    <path
      class="checkmark"
      d="M7.52709 12.8574C7.46538 12.8574 7.40366 12.8338 7.35641 12.787L3.49923 8.92981C3.40521 8.83579 3.40521 8.68295 3.49923 8.58893C3.59324 8.49492 3.74609 8.49492 3.8401 8.58893L7.52709 12.2754L14.5886 5.21341C14.6827 5.11939 14.8355 5.11939 14.9295 5.21341C15.0235 5.30743 15.0235 5.46027 14.9295 5.55429L7.69729 12.7865C7.65052 12.8338 7.58881 12.8574 7.52709 12.8574Z"
    />
  </svg>
</ng-template>

<ng-template #roundedCheckBox>
  <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      class="border"
      x="1"
      y="0.5"
      width="18"
      height="18"
      rx="9"
      stroke="white"
      stroke-linecap="round"
      stroke-dasharray="1 3"
    />
    <rect class="checkmark" x="1" y="0.5" width="18" height="18" rx="9" stroke="white" />
    <path
      class="checkmark"
      d="M8.33609 13.2502C8.28209 13.2502 8.22809 13.2295 8.18674 13.1886L4.8117 9.81355C4.72943 9.73129 4.72943 9.59755 4.8117 9.51528C4.89397 9.43302 5.0277 9.43302 5.10997 9.51528L8.33609 12.741L14.5149 6.5617C14.5972 6.47943 14.7309 6.47943 14.8132 6.5617C14.8955 6.64397 14.8955 6.7777 14.8132 6.85997L8.48501 13.1882C8.44409 13.2295 8.39009 13.2502 8.33609 13.2502Z"
      fill="white"
      stroke="white"
    />
  </svg>
</ng-template>
